export function createZoomInButtonClickEvent(zoomScale) {
  return {
    eventType: 'ui',
    action: 'clicked',
    actionSubject: 'button',
    actionSubjectId: 'zoomIn',
    attributes: {
      zoomScale: zoomScale
    }
  };
}